import { isBrowser } from './safeLocation';

const getScreenSize = () => {
  if (!isBrowser) return 'lg';
  const width = window.innerWidth;
  // Tailwind default breakpoints
  if (width < 640) {
    return 'xs'; // Below sm
  }
  if (width < 768) {
    return 'sm'; // 640px - 767px
  }
  if (width < 1024) {
    return 'md'; // 768px - 1023px
  }
  if (width < 1280) {
    return 'lg'; // 1024px - 1279px
  }
  if (width < 1536) {
    return 'xl'; // 1280px - 1535px
  }
  return '2xl'; // 1536px and above
};

export default getScreenSize;
